import { AST } from '../ast';
import { hashLiteral } from './hash-literal';
import _ from 'lodash';

const HASH_CACHE: WeakMap<AST.Mu, string> = new WeakMap();

export const hashMarkup = (markup: AST.Mu): string => {
  const existing = HASH_CACHE.get(markup);

  if (existing) {
    return existing;
  }

  const res = hashLiteral(markup, { algorithm: 'md5' });

  HASH_CACHE.set(markup, res);
  return res;
};
